/**
 * Resolve which OAuth provider to use for a simple Instagram connect.
 * When Instagram Login is enabled in global config → `instagram`.
 * Otherwise → Facebook Login (`meta`) until Meta approves.
 */
export type InstagramConnectProvider = 'instagram' | 'meta';

export function resolveInstagramConnectProvider(
    buzzBridgeConfig?: { instagram_login_enabled?: boolean } | null,
): InstagramConnectProvider {
    return buzzBridgeConfig?.instagram_login_enabled === true ? 'instagram' : 'meta';
}

/** Provider for heavy Instagram tasks (publish / automation) — always Facebook Login. */
export const INSTAGRAM_FACEBOOK_UPGRADE_PROVIDER = 'meta' as const;

type InstagramCapabilityRow =
    | {
          facebook_upgrade_required?: boolean;
          publish_blocked_reason?: string | null;
          auth_flow?: string;
          publish_ready?: boolean;
      }
    | null
    | undefined;

export function needsFacebookUpgradeForInstagram(row?: InstagramCapabilityRow): boolean {
    if (!row) return false;
    if (row.facebook_upgrade_required) return true;
    if (row.publish_blocked_reason === 'facebook_login_required') return true;
    if (row.auth_flow === 'instagram_login' && row.publish_ready === false) return true;
    return false;
}
